import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import type { LoaderRenderProps } from './loader-render.types.ts';
import styles from './loader-render.module.scss';

export function LoaderRender({ message, size = '3x' }: LoaderRenderProps) {
  return (
    <div className={styles.render}>
      <div className={styles.loaderWrapper}>
        <div className={styles.loaderCircle}></div>
        <FontAwesomeIcon icon={faCircleNotch} size={size} spin={true} />
      </div>
      <span>{message}</span>
    </div>
  );
}
